import axios from "axios";
import utils from "@/utils/utils";
const localUrl = window.location.origin;

const baseURL = utils.getDomainUrl();


const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json; charset=UTF-8"
  },
  withCredentials: true,
  timeout: 5000
});

axiosInstance.interceptors.request.use(
  function(config) {
    if (config.method == "post") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (config.url.indexOf("/local/") !== -1) {
      config.url =
        localUrl +
        (config.url.indexOf("http://") !== -1
          ? config.url.split(config.baseURL)[1]
          : config.url);
      config.baseURL = localUrl;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function(response) {
    if (response.data.code == 0) {
      return (response = response.data);
    }

    return Promise.reject(new Error(response.data.msg));
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/utils/ajax.js